import { HStack, Icon, Image, Spinner, Text, VStack, chakra } from '@chakra-ui/react';
import iconFile from 'assets/icons/icon-file.svg';
import IconSelectBoxCircle from 'assets/icons/icon-select-box-circle.svg?react';
import IconUploadCloud from 'assets/icons/icon-upload-cloud.svg?react';
import ButtonRemove from 'components/ui/ButtonRemove';
import { useCreateAsset } from 'features/assets/hooks/useCreateAsset';
import numeral from 'numeral';
import { PropsWithChildren, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

type UploadAssetProps = PropsWithChildren<{
  defaultValue?: string;
  onChange: (url: string) => void;
  accept?: any;
  description?: string;
  asFile?: boolean;
}>

export default function UploadAsset({ 
  defaultValue, 
  onChange, 
  accept = { 'image/*': ['.jpeg', '.png'] },
  description = 'JPEG ou PNG até 5MB',
  asFile,
  children
}: UploadAssetProps) {
  const value = asFile ? defaultValue : (defaultValue ? { url: defaultValue } : null);
  const [asset, setAsset] = useState<any>(value);
  const { onCreateAsset, isPending } = useCreateAsset({
    onSuccess: ({ data: { asset} }) => {
      setAsset(asset);
      onChange(asFile ? asset : asset.url);
    },
    onError: (data) => {
      //console.log('error', data)
    }
  });

  const onDrop = useCallback(async (acceptedFiles) => onCreateAsset({ file: acceptedFiles[0] }), []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop, 
    accept
  });

  if (isPending) {
    return (
      <SolidHStack>
        <Spinner />   
      </SolidHStack>
    )
  }
  else if (asset)
    return (
      <SolidHStack>
      { asFile ? <Image src={iconFile} /> : <Image maxW="150px" src={asset?.url} /> }
        
      { asset?.fileName && (
        <VStack alignItems="flex-start">
          <Text as="span" fontWeight={500}>{asset.fileName}</Text>
          <HStack
            fontSize="12px"
            spacing="3px"
          >
            <Text as="span" color="#525866">{numeral(asset.contentLength).format('0b')}</Text>
            <Icon as={IconSelectBoxCircle} ml="10px" />
            <Text as="span">Arquivo enviado</Text>
          </HStack>
          {children}
        </VStack>
      )}
        <ButtonRemove ml="auto" clean onClick={() => {
          setAsset(null);
          onChange(null);
        }} />
      </SolidHStack>
    ) 
  else 
    return (
      <DashedVStack {...getRootProps()}>
        <input {...getInputProps()} />
        <IconUploadCloud />
      { isDragActive ?
        <Text>Solte o arquivo aqui...</Text> :
        <Text textAlign="center">
          <strong>Escolha ou arraste um arquivo</strong><br />
          {description}
        </Text>
      }
        
      </DashedVStack>
    )
}


const SolidHStack = chakra(HStack, {
  baseStyle: {
    p: '16px',
    spacing: '12px',
    borderRadius: '12px',
    border: '1px solid #E1E4EA',
    minH: '100px'
  }
});

const DashedVStack = chakra(VStack, {
  baseStyle: {
    borderRadius: '12px',
    border: '1px dashed #CACFD8',
    spacing: '20px',
    p: '32px',
    cursor: 'pointer',
    h: '150px',
  }
});